import {
    POST_ROLE,
    POST_ROLE_SUCCESS,
    POST_ROLE_ERROR,
  } from '../../../constants/constantsRed';
  
  export const postRoleRed = (
    state: any = false,
    actions: any
  ) => {
    switch (actions.type) {
      case POST_ROLE:
        return {
          ...state,
          loading: true,
        };
      case POST_ROLE_ERROR:
        return {
          data: null,
          loading: false,
          error: null,
        };
      case POST_ROLE_SUCCESS:
        return {
          ...state,
          loading: false,
          error: null,
          data: actions.payload,
        };
      default:
        return state;
    }
  };
  